import { Component, OnInit } from '@angular/core';
//import { shuttle } from '../data/shuttle';
import {CookieService} from 'angular2-cookie/core';
import {Router} from "@angular/router";
import {shuttleService,iShuttle} from "../data/shuttle.service";
import {Location} from '@angular/common';

@Component({
  selector: 'app-shuttle',
  templateUrl: './shuttle.component.html',
  styleUrls: ['./shuttle.component.css'],
 // providers: [ CookieService ],

})

export class ShuttleComponent  implements OnInit {
     app_active: boolean = false;
     //all_shuttles: iShuttle[] = [];
     loginMessage:string = '';
     driver_id:number;
     shuttle:iShuttle;// = {id:0,name:''};
     now: string;
     timer: string = '00:00';
     thinking:boolean = false;
     msg:string = '';



     constructor(private _cookieService:CookieService, private router:Router,private myShuttle:shuttleService,private _location:Location){
          console.log('******* shuttle component constructor ******* ');
          this.startThinking();
          console.log('+++++++ shuttle component constructor END +++++++');
     }

     startThinking(){
          console.log('++++++++++++++++++++  THINKING');
          this.thinking = true;
     }
     stopThinking(){
          this.thinking = false;
          console.log('++++++++++++++++++++  STOP THINKING');
     }

     formatTimer(){
          let timer_parts = this.timer.split(':');
          let minutes = parseInt(timer_parts[0]);
          let seconds = parseInt(timer_parts[1]);
          seconds = seconds +1;
          let new_sec:string = '';
          let new_min:string = '';

          if(seconds >59){
               minutes = minutes + 1;
               seconds = 0;
          }
          if(minutes <0 ){
               minutes = 0;
          }

          if(seconds <0 ){
               seconds = 0;
          }

          if(minutes < 10){
               new_min = "0"+minutes;
          } else {
               new_min = minutes.toFixed(0);;
          }

          if(seconds < 10){
               new_sec = "0"+seconds;
          } else {
               new_sec = seconds.toFixed(0);

          }
          if(parseInt(new_min) < 0 || parseInt(new_min)>59){
               new_min = '00';
          }
          if(parseInt(new_sec) < 0 || parseInt(new_sec)>59){
               new_sec = '00';
          }
          return new_min + ':' + new_sec;

     }
     formatDate(date) {
       var hours = date.getHours();
       var minutes = date.getMinutes();
       hours = hours < 10 ? '0'+hours : hours;
       minutes = minutes < 10 ? '0'+minutes : minutes;
       var strTime = hours + ':' + minutes ;
       return strTime;
     }

     set_app_shuttle_id(id){
          console.log('set_app_shuttle_id');
          this.myShuttle.getShuttleById(id).subscribe((response)=>{
               console.log('getShuttleById response');
               let data = response.json();
               console.log(data);
               this.shuttle = data;
               this.save_cookie('app_shuttle',id);
               console.log('end getShuttleById response');
          });
          console.log('end set_app_shuttle_id');
     }

     ngOnInit(){
          console.log('MASTER ngOnInit');
          this.startThinking();
          var ts = parseInt(this.get_cookie('app_shuttle'));
          var td = parseInt(this.get_cookie('app_driver'));
          if(ts){
               this.startThinking();
               this.myShuttle.getShuttleById(ts).subscribe((response)=>{
                    console.log('getShuttleById response');
                    let data = response.json();
                    console.log(data);
                    this.shuttle = data;
                    if(!(td > 0)){
                         this.myShuttle.assignDriverToShuttle(this.shuttle.id,'');
                    }
                    this.now = this.formatDate(new Date());

                    let shuttleTimerStart = this.shuttle.last_arrival_time;
                    var diff = new Date().getTime() - new Date(shuttleTimerStart).getTime();
                    console.log('x');
                    console.log(diff);
                    if(diff < 0){
                         diff = 0;
                    }
                    let diff_min = diff/1000/60;
                    let timer_minutes:any = Math.floor(diff_min);
                    let diff_for_seconds = diff - (timer_minutes*60000);
                    let timer_seconds:any = Math.floor(diff_for_seconds/1000);

                    if(timer_seconds < 10){
                         timer_seconds = '0'+timer_seconds.toLocaleString() ;
                    }
                    if(timer_minutes < 10){
                         timer_minutes = '0'+timer_minutes.toLocaleString();
                    }
                    if(parseInt(timer_minutes) < 0 || parseInt(timer_minutes)>59){
                         timer_minutes = '00';
                    }
                    if(parseInt(timer_seconds) < 0 || parseInt(timer_seconds)>59){
                         timer_seconds = '00';
                    }

                    this.timer = timer_minutes + ':' + timer_seconds;
                    setInterval(()=>{
                         this.now = this.formatDate(new Date());
                    },1000)

                    setInterval(()=>{
                         this.timer = this.formatTimer();
                    },1000);
                    this.stopThinking();

               });
          }
          this.stopThinking();

     }

     refresh_shuttle(){
          console.log('refresh_shuttle' + this.shuttle.id);
          if(!(this.shuttle.id>=0) ){
               this.shuttle.id = 0;
          }
          return this.myShuttle.getShuttleById(this.shuttle.id).map((response)=>{
               console.log('getShuttleById response');
               let data = response.json();
               console.log(data);
               this.shuttle = data;
               return data;
          });
     }

     go_back_history(){
          console.log('go_back_history');
          this._location.back();
     }

     app_deactivate(){
          console.log('app_deactivate');
          this.app_active = false;
     }

     startup_shuttle(){
          console.log('startup_shuttle');
          this.startThinking();
          if(this.shuttle){
               if(this.shuttle.id >0){
                    this.app_active = true;
               }
          }
          this.stopThinking();
     }

     start_shuttle(route,start,stop){
          console.log('start_shuttle');
          console.log('route: ' + route);
          console.log('start: ' + start);
          console.log('stop: ' + stop);
          this.startThinking();
          if(route > 0 && start>0 && stop>0){
               if(this.shuttle.id >0){
                    this.myShuttle.assignRouteToShuttle(this.shuttle.id,route,start,stop).subscribe((response)=>{
                         console.log('assignRouteToShuttle response');
                         //this.leave_stop('start');//this.myShuttle.leaveStop
                         this.myShuttle.leaveStop(this.shuttle.id,'start').subscribe((response)=>{
                         console.log('leaveStop response');
                              let data = response.json();
                              if(data.success == true){
                                   this.refresh_shuttle().subscribe((response)=>{
                                        this.stopThinking();
                                        this.router.navigate(['/shuttle/en-route']);
                                   });
                              } else {
                                   this.stopThinking();
                                   alert('Please wait 30 seconds and try again.');
                              }
                         });
                    });
               }

          }
     }

          start_shuttle_from_deviate(route,start,stop,new_stop){
          this.startThinking();
          console.log('start_shuttle_from_deviate');
          console.log('route: ' + route);
          console.log('start: ' + start);
          console.log('stop: ' + stop);
          console.log('new_stop: ' + new_stop);
          if(start && !stop){
              start = start;
         } else if(!start && stop){
              start = stop;
         }
         console.log(route);
         console.log(start);
         console.log(new_stop);
         console.log('--------------------');
         console.log('start: ' + start);
         console.log('stop: ' + new_stop);
          if(route > 0 && start>0 && new_stop>0){
               if(this.shuttle.id >0){
                    this.myShuttle.assignRouteToShuttle(this.shuttle.id,route,start,new_stop).subscribe((response)=>{
                         console.log('assignRouteToShuttle response');
                         this.myShuttle.leaveStop(this.shuttle.id,'deviate').subscribe((response)=>{
                              let data = response.json();
                              console.log('leaveStop response');
                              console.log(data);
                              if(data.success == true){
                                   this.refresh_shuttle().subscribe((response)=>{
                                        console.log(this.shuttle);
                                        console.log('before deviaet back to route');
                                        this.stopThinking();

                                        this.router.navigate(['/shuttle/en-route']);
                                   });
                              } else {
                                   this.stopThinking();
                                   alert('Please wait 30 seconds and try again.');
                              }
                         });
                    });
               }
          }
     }


      at_stop(type){
           this.startThinking();
           console.log('at_stop');
           //tell site we stopped
           this.myShuttle.reachedStop(this.shuttle.id,type).subscribe((response)=>{
               let data = response.json();
                if(data.success == true){
                     this.refresh_shuttle().subscribe((response)=>{
                          console.log('refresh_shuttle at_stop' );
                          this.stopThinking();
                          this.router.navigate(['/shuttle/at-stop']);
                     });
                } else {
                     alert('Please wait 30 seconds and try again.');
                     this.stopThinking();

                }
           });
      }

     app_login(driver,pin){
          if(!driver || !pin){
               this.loginMessage = 'Please enter a pin and password';
          }

          this.myShuttle.driver_login(driver,pin).subscribe((response)=>{
               //console.log('response');
               //console.log(response.json());
               let d_id = response.json().id;
               if(d_id > 0){
                    //assign driver to shuttle
                    //console.log('this assign');
                    console.log('new');
                    this.myShuttle.assignDriverToShuttle(this.shuttle.id,d_id).subscribe((response)=>{
                        let data = response.json();
                         if(data.success == true){
                              this.refresh_shuttle().subscribe((response)=>{
                                   this.save_cookie('app_driver',d_id);
                                   console.log('refresh_shuttle app_login' );
                                   this.stopThinking();
                                   this.router.navigate(['/shuttle/start']);
                                   //this.router.navigate(['/shuttle/at-stop']);
                              });
                         } else {
                              alert('Please wait 30 seconds and try again.');
                              this.stopThinking();

                         }
                    });
                    //alert('almost refresh');
                    //this.refresh_shuttle();

                    //alert(this.shuttle.driver_id);
                    //this.shuttle.driver_id = d_id;
                    //this.save_cookie('app_driver',d_id);
               } else {
                    this.loginMessage = 'Invalid ID or Passcode';
               }
               //console.log(this.shuttle);

          });

     }


     validate_shuttle_id(id){
          //console.log('validate_shuttle_id: ' + id);
          //need to validate id but for now im assuming its valid
          return true;
     }




     //cookie - needs refactor
     get_cookie(key: string){
          //console.log(this._cookieService);
          //console.log('get key: ' + key);
          return this._cookieService.get(key);
     }

     save_cookie(key,value){
          //need to set expiration
          this._cookieService.put(key, value);
    }


 close_delay(){
    this._location.back();
 }


 leave_stop(type){ //type: start routing deviating
      this.startThinking();
      console.log('leave_stop');
      this.myShuttle.leaveStop(this.shuttle.id,type).subscribe((response)=>{
           console.log('leaveStop response');
           let data = response.json();
           console.log(data);
           if(data.success == true){
                this.refresh_shuttle().subscribe((response)=>{
                     console.log('refresh_shuttle response');
                     this.stopThinking();
                     this.router.navigate(['/shuttle/en-route']);
                });
           } else {
                this.stopThinking();
                alert('Please wait 30 seconds and try again.');
           }
      });
 }


 reset_shuttle(){
      //need to reset shuttle before setting
 }
 shuttle_cancel_break(){
      console.log('cancel break');
      this._location.back();

}
shuttle_go_on_break(){
     this.myShuttle.takeABreakShuttle(this.shuttle.id);
     this.router.navigate(['/shuttle/start']);
}
 take_break(){
      console.log('take_break');
      this.router.navigate(['/shuttle/break']);
 }

 deviate_to(stop_id){
      this.startThinking();
      console.log('deviate_to');
      this.myShuttle.promise_assignRouteToShuttle(this.shuttle.id,this.shuttle.route.id,this.shuttle.lastStop,stop_id).subscribe(
      (response)=>{
           console.log('promise_assignRouteToShuttle response');
           this.myShuttle.leaveStop(this.shuttle.id,'deviating').subscribe((response)=>{
                console.log('leaveStop response');
                let data = response.json();
                console.log(data);
                this.refresh_shuttle().subscribe((response)=>{
                     this.stopThinking();
                     this.router.navigate(['/shuttle/deviate-en-route']);
                });
           });
      }
);

 }

 end_deviation(){
      console.log('end_deviation');
      //reset shuttle
      this.router.navigate(['/shuttle/start']);
 }


 delay_shuttle(){
      console.log('delay_shuttle');
      this.router.navigate(['/shuttle/set-delay']);
 }


 deactivate_shuttle(){
      console.log('deactivate_shuttle');

      this.router.navigate(['/shuttle/deactivate']);
 }

 deactive_approved(){
     console.log('deactive_approved');
     //this.save_cookie('app_shuttle',0);
     this.save_cookie('app_driver',0);
     this.myShuttle.resetShuttle(this.shuttle.id).subscribe((response)=>{
          this.router.navigate(['/login']);
     });
     //this.myShuttle.resetShuttle(shuttle_id);


 }
 deactive_cancelled(){
     console.log('deactive_cancelled');
     this._location.back();

 }

 deviate_route(){
      console.log('deviate_route');
      this.router.navigate(['/shuttle/deviate-route']);
 }

 deviate_at_stop(){
      console.log('deviate_at_stop');

      this.startThinking();
      console.log('deviate_to');
      this.myShuttle.reachedStop(this.shuttle.id,'deviating').subscribe((response)=>{
           console.log('reachedStop response');
           let data = response.json();
           console.log(data);
           this.refresh_shuttle().subscribe((response)=>{
                this.stopThinking();
                this.router.navigate(['/shuttle/deviate-stop']);
           });
      });









}

 set_delay(minutes){
      console.log('set_delay');
      this.startThinking();
      this.myShuttle.setDelay(this.shuttle.id,minutes).subscribe((response)=>{
               this.refresh_shuttle().subscribe((response)=>{
                    console.log('set_delay');
                    this.stopThinking();
               });
      });
 }
}
